import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PmeFilterOptions } from '@usf/ngrx-list';

@Component({
  selector: 'app-pme-list-filter-buttons',
  templateUrl: './pme-list-filter-buttons.component.html',
  styleUrls: ['./pme-list-filter-buttons.component.scss'],
})
export class PmeListFilterButtonsComponent {
  @Input() platformType: string;
  @Input() set filters(value: string[]) {
    this._filters = value || [];
    this.updateActiveStates();
  }
  @Output() filtersChange = new EventEmitter<string[]>();

  readonly FilterType = PmeFilterOptions;
  private _filters: string[] = [];
  activeStates = {
    [PmeFilterOptions.showAllPriceChange]: false,
    [PmeFilterOptions.notInOptimizedRange]: false,
    [PmeFilterOptions.showAllMarketChange]: false,
  };

  constructor() {}

  private updateActiveStates() {
    Object.keys(this.activeStates).forEach(key => {
      this.activeStates[key] = this._filters.includes(key);
    });
  }

  onPriceChangedClick() {
    this.toggleFilter(PmeFilterOptions.showAllPriceChange);
  }

  onNotInOptimizedRangeClick() {
    this.toggleFilter(PmeFilterOptions.notInOptimizedRange);
  }

  onMarketChangedClick() {
    this.toggleFilter(PmeFilterOptions.showAllMarketChange);
  }

  private toggleFilter(filterType: PmeFilterOptions) {
    const updatedFilters = [...this._filters];
    const index = updatedFilters.indexOf(filterType);

    if (index === -1) {
      updatedFilters.push(filterType);
    } else {
      updatedFilters.splice(index, 1);
    }

    updatedFilters.sort((a, b) => {
      const order = {
        [PmeFilterOptions.showAllPriceChange]: 0,
        [PmeFilterOptions.notInOptimizedRange]: 1,
        [PmeFilterOptions.showAllMarketChange]: 2,
      };
      return order[a] - order[b];
    });

    this.filtersChange.emit(updatedFilters);
  }
}
